import { DataStore } from "aws-amplify";
import { TeamMember } from "../../../models";
import { TeamMemberDAO } from "./TeamMemberDAO";

export class DataStoreTeamMemberDAO implements TeamMemberDAO {
    public async listByUserId(userId: string): Promise<TeamMember[]> {
        return await DataStore.query(TeamMember, teamMember => teamMember.userId("eq", userId));
    }

    public async listByTeamId(teamId: string): Promise<TeamMember[]> {
        return await DataStore.query(TeamMember, teamMember => teamMember.teamId("eq", teamId));
    }
}

export const dataStoreTeamMemberDAO = new DataStoreTeamMemberDAO();